const ACADEMY_PREFIX = "/academy";

export const StorageItemDetailsApiEndpoints = {
  FETCH_STORAGE_ITEM_FAVORITE_STATE: `${ACADEMY_PREFIX}/storage/favorite`,
  ADD_FAVORITE_STORAGE_ITEM: `${ACADEMY_PREFIX}/storage/favorite`,
  DELETE_FAVORITE_STORAGE_ITEM: `${ACADEMY_PREFIX}/storage/favorite`,
  FETCH_STORAGE_ITEM_PRESIGNED_URL: `${ACADEMY_PREFIX}/file/presigned-url`,
  DELETE_STORAGE_ITEM: `${ACADEMY_PREFIX}/storage/organization`,
  FETCH_PEOPLE_AND_TEAMS_TO_SHARE: `${ACADEMY_PREFIX}/storage/share/organization`,
  SHARE_STORAGE_ITEM: `${ACADEMY_PREFIX}/storage/share/organization`,
  CREATE_NEW_TAG: `${ACADEMY_PREFIX}/storage/tag`,
  DELETE_TAG: `${ACADEMY_PREFIX}/storage/tag`,
  SEARCH_TAGS: `${ACADEMY_PREFIX}/storage/tag`,
  GET_STORAGE_ITEM_TAG_FOR_STORAGE_ITEM: `${ACADEMY_PREFIX}/storage/tag/storage-item`
};
